<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="cog" style="width: 50px; height: 50px;"/> Gegevens wijzigen
    </div>
    <div class="card-content" @click="$parent.redo()">
      <awesomeIcon icon="address-card" style="width: 50px; height: 50px;"/>
      <h3>
        Is uw situatie veranderd, andere tegenrekening of bent u verhuisd?
      </h3>
      <p class="grey">
        Klik <u>hier</u> om uw wijzigingen door te geven.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goalChangerWidget',
  data() {
    return {
    };
  },
};
</script>
<style lang="scss" scoped>
.card-content {
  color: $color-background;
  text-align: center;
  padding: 0 20px !important;
  cursor:pointer;
  .grey {
    cursor: pointer;
  }
}
</style>
